/*
 * @Auther: 罗耀祖
 * @Date: 2021-07-06 15:18:09
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-08-24 14:17:29
 * @name: 路由表
 * @Description: 路由表
 * @FilePath: \preSaleNafterSaleBackstage\src\router\index.js
 * @Author: DESKTOP-1QU67QM
 */
import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'
import setPageTitle from '@/utils/set-page-title.js';
import whiteList from '@/config/whiteList.config';
import cookie from "@/storage/cookie";

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: '',
    redirect: '/index'
  },
  {
    path: '/index',
    name: 'index',
    component: () => import('@/views/Index.vue'),
    redirect: '/index/welcome',
    meta: {
      keepalive: true,
      title: '主页',
    },
    children: [
      {
        path: 'welcome',
        name: 'welcome',
        component: () => import('@/views/welcome/welcome.vue'),
        meta: {
          keepalive: true,
          title: '',
        },
      },
      {
        path: 'mailList',
        name: 'mailListRouter',
        component: () => import('@/views/mailList/mailListRouter.vue'),
        redirect: '/index/mailList/mailList',
        meta: {
          keepalive: true,
          title: '通讯录',
        },
        children: [
          {
            path: 'mailList',
            name: 'mailList',
            component: () => import('@/views/mailList/mailList.vue'),
            meta: {
              activePath: '/index/mailList',
              keepalive: true,
              title: '通讯录',
            }
          },
        ]
      },
      {
        path: 'pianoCompanyManage',
        name: 'pianoCompanyManageRouter',
        component: () => import('@/views/pianoCompanyManage/pianoCompanyManageRouter.vue'),
        redirect: '/index/pianoCompanyManage/pianoCompanyManage',
        meta: {
          keepalive: true,
          title: '琴行管理',
        },
        children: [
          {
            path: 'pianoCompanyManage',
            name: 'pianoCompanyManage',
            component: () => import('@/views/pianoCompanyManage/pianoCompanyManage.vue'),
            meta: {
              activePath: '/index/pianoCompanyManage',
              keepalive: true,
            }
          },
        ]
      },
      {
        path: 'approvalManage',
        name: 'approvalManageRouter',
        component: () => import('@/views/approvalManage/approvalManageRouter.vue'),
        redirect: '/index/approvalManage/flowManage',
        meta: {
          keepalive: true,
          title: '审批管理',
        },
        children: [
          {
            path: 'flowManage',
            name: 'flowManage',
            component: () => import('@/views/approvalManage/flowManage.vue'),
            meta: {
              activePath: '/index/approvalManage',
              keepalive: true,
              title: '工作流管理',
            }
          },
          {
            path: 'flowManageDesign',
            name: 'flowManageDesign',
            component: () => import('@/views/approvalManage/flowManageDesign.vue'),
            meta: {
              activePath: '/index/approvalManage',
              keepalive: false,
              title: '工作流设计',
            }
          },
          {
            path: 'discountApprovalManage',
            name: 'discountApprovalManage',
            component: () => import('@/views/approvalManage/discountApprovalManage.vue'),
            meta: {
              activePath: '/index/approvalManage',
              keepalive: true,
              title: '折扣审批',
            }
          },
          {
            path: 'delayApprovalManage',
            name: 'delayApprovalManage',
            component: () => import('@/views/approvalManage/delayApprovalManage.vue'),
            meta: {
              activePath: '/index/approvalManage',
              keepalive: true,
              title: '延期审批',
            }
          },
          {
            path: 'afterSalesApprovalManage',
            name: 'afterSalesApprovalManage',
            component: () => import('@/views/approvalManage/afterSalesApprovalManage.vue'),
            meta: {
              activePath: '/index/approvalManage',
              keepalive: true,
              title: '售后审批',
            }
          },
          {
            path: 'payConfirmManage',
            name: 'payConfirmManage',
            component: () => import('@/views/approvalManage/payConfirmManage.vue'),
            meta: {
              activePath: '/index/approvalManage',
              keepalive: true,
              title: '支付确认',
            }
          },
        ]
      },
      {
        path: 'issueManage',
        name: 'issueManageRouter',
        component: () => import('@/views/issueManage/issueManageRouter.vue'),
        redirect: '/index/issueManage/issueListManage',
        meta: {
          keepalive: true,
          title: '工单管理',
        },
        children: [
          {
            path: 'issueListManage',
            name: 'issueListManage',
            component: () => import('@/views/issueManage/issueListManage.vue'),
            meta: {
              activePath: '/index/issueManage',
              keepalive: true,
              title: '工单管理',
            }
          },
        ]
      },
      {
        path: 'approvalListManage',
        name: 'approvalListManageRouter',
        component: () => import('@/views/approvalListManage/approvalListManageRouter.vue'),
        redirect: '/index/approvalListManage/orderApprovalListManage',
        meta: {
          keepalive: true,
          title: '订单管理',
        },
        children: [
          {
            path: 'orderApprovalListManage',
            name: 'orderApprovalListManage',
            component: () => import('@/views/approvalListManage/orderApprovalListManage.vue'),
            meta: {
              activePath: '/index/approvalListManage',
              keepalive: true,
              title: '订单管理',
            }
          },
        ]
      },
      {
        path: 'goodsManage',
        name: 'goodsManageRouter',
        component: () => import('@/views/goodsManage/goodsManageRouter.vue'),
        redirect: '/index/goodsManage/waresGoodsManage',
        meta: {
          keepalive: true,
          title: '商品管理',
        },
        children: [
          {
            path: 'modelGoodsManage',
            name: 'modelGoodsManage',
            component: () => import('@/views/goodsManage/modelGoodsManage.vue'),
            meta: {
              activePath: '/index/goodsManage',
              keepalive: true,
              title: '品牌系列型号管理',
            }
          },
          {
            path: 'waresGoodsManage',
            name: 'waresGoodsManage',
            component: () => import('@/views/goodsManage/waresGoodsManage.vue'),
            meta: {
              activePath: '/index/goodsManage',
              keepalive: true,
              title: '商品管理',
            }
          },
        ]
      },
      {
        path: 'setting',
        name: 'settingRouter',
        component: () => import('@/views/setting/settingRouter.vue'),
        redirect: '/index/setting/setting',
        meta: {
          keepalive: true,
          title: '设置',
        },
        children: [
          {
            path: 'setting',
            name: 'setting',
            component: () => import('@/views/setting/setting.vue'),
            meta: {
              activePath: '/index/setting',
              keepalive: true,
              title: '设置',
            }
          }
        ]
      },
      {
        path: 'jurisdiction',
        name: 'jurisdictionRouter',
        component: () => import('@/views/jurisdiction/jurisdictionRouter.vue'),
        redirect: '/index/jurisdiction/person',
        meta: {
          keepalive: true,
          title: '权限管理',
        },
        children: [
          {
            path: 'person',
            name: 'person',
            component: () => import('@/views/jurisdiction/person.vue'),
            meta: {
              activePath: '/index/jurisdiction',
              keepalive: true,
              title: '后台管理',
            }
          },
          {
            path: 'role',
            name: 'role',
            component: () => import('@/views/jurisdiction/role.vue'),
            meta: {
              activePath: '/index/jurisdiction',
              keepalive: true,
              title: '角色管理',
            }
          }
        ]
      },
    ]
  }, //主页
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/Login.vue'),
    meta: {
      title: '登录',
    }
  }, //登录
  {
    path: '/forgetPassword',
    name: 'forgetPassword',
    component: () => import('@/views/ForgetPassword.vue'),
    meta: {
      title: '忘记密码',
    }
  }, //忘记密码
  {
    path: '/register',
    name: 'register',
    component: () => import('@/views/Register.vue'),
    meta: {
      title: '注册',
    }
  }, //注册
  {
    path: '/preSaleNafterSaleDistributorApp',
    name: 'preSaleNafterSaleDistributorApp',
    component: () => import('@/views/preSaleNafterSaleDistributorApp.vue'),
    meta: {
      title: '',
    }
  }, //海伦易购app下载页
  {
    path: '/preSaleNafterSaleInsideApp',
    name: 'preSaleNafterSaleInsideApp',
    component: () => import('@/views/preSaleNafterSaleInsideApp.vue'),
    meta: {
      title: '',
    }
  }, //海伦业务助手app下载页
  {
    path: '/401',
    component: () => import('@/views/errPage/401.vue'),
  },
  {
    path: '*',
    redirect: '/404'
  },
  {
    path: '/404',
    component: () => import('@/views/errPage/404.vue'),
  },
]

const router = new VueRouter({
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  let role_id = new cookie().getRoleId() ?? ''; //角色id,admin为超级管理员
  let auth_url = new cookie().getAuthList() ?? []; //权限列表
  if (role_id !== 'admin' && !auth_url.includes(to.path) && !whiteList.includes(to.path)) {
    next('/401');
  } else {
    const title = getPageTitle(to);
    // 设置页面缓存,跳转登录等页面时清空缓存
    if (['login'].includes(to.name)) {
      store.dispatch("cashView/clearCashRouters");
    } else {
      store.dispatch("cashView/addCashRouters", to);
    }
    title && (document.title = setPageTitle(title)); //设置标题
    next();
  }
})

/**
 * @Auther: 罗耀祖
 * @LastEditors: 罗耀祖
 * @description: 获取路由标题
 * @param {Object} to 路由信息
 * @return {String} 路由标题
 */
const getPageTitle = (to) => {
  let title = to?.matched?.reverse()?.find(x => x.meta.title)?.meta?.title ?? ''; //倒序查询title
  to?.matched?.reverse(); //reverse会改变原数组,重置回去
  return title;
}

export default router;
